import React from 'react'
import styled from "styled-components"
import Naza from './Images/Naza.jpeg'
import Shadrack from './Images/Shadrack.jpeg'
import Kudus from './Images/Kudus.jpeg'
import Tope from './Images/Tope.jpeg'
import Samod from './Images/Samod.jpeg'
import Adebowale from './Images/Adebayo Dare.png'
import Chidi from './Images/Chidi.jpeg'
import Michael from './Images/Michael.jpeg'
import Adekoya from './Images/Daniel Adekoya.jpg'
import Lekan from './Images/Olamilekan Oyedokun.jpeg'
import Sultan from './Images/Sultan Baruwa.jpeg'
import Toba from './Images/Ipense Toba.jpeg'



function wildwest() {
    return (
        <div>
            <h1>WILD-WEST BALLERS</h1>
            <h3>OWNER: Michael Simon </h3>
            <br/>
            <Div>
                <div><Img src={Michael}/> Simon Michael</div><br/>
                <div><Img src={Sultan}/> Sultan</div><br/>
                <div><Img src={Kudus}/> Tanimowo Kudus</div><br/>
                <div><Img src={Tope}/> Obisanya Temitope</div><br/>
                <div><Img src={Shadrack}/> Shadrack Musa</div><br/>
                <div><Img src={Naza}/> Ekeala Naza</div><br/>
                <div><Img src={Toba}/> Ipense Toba</div><br/>
                <div><Img src={Lekan}/> Olamilekan</div><br/>
                <div><Img src={Chidi}/> Ibeh Chidi</div><br/>
                <div><Img src={Adekoya}/> Daniel Adekoya</div><br/>
                <div><Img src={Adebowale}/> Adebowale</div><br/>
                <div><Img src={Chidi}/> Idehen Nosa</div><br/>
                <div><Img src={Samod}/> Sogunro Samod</div><br/>
            </Div>
    
            
        </div>
      )
}

export default wildwest

const Img = styled.img`
height: 300px;
width: 300px;
@media screen and (max-width: 750px) {
  height: 150px;
  width: 150px;
}
`

const Div = styled.div`
font-size: 20px;
font-weight: bold;
`